'use strict';

function controller ($q, viewport, listingService, sellerService, dealerChatService, alsService, recentActivityService, pageStateService, userDataService, localStorageService, latLong, $window, $location, $document) {
    const ctrl = this;

    ctrl.$onInit = function () {
        listingService.getListing().then(data => {
            const listingDetail = data.listingDetailDto;
            sendPageStateUpdateDTM(listingDetail);
            _sendAlsTracking(listingDetail);
            if (listingDetail.onlineShopperV2) {
                setOnlineShopperTracking();
            }
            if (listingDetail.isFiveStar) {
                setFiveStarSalesPersonTracking();
            }
            setDigitalLayerPageLoadValue();
            recentActivityService.saveRecentViewed(listingDetail);
        });
        _updateDataVerticalPositionDTM();
    };

    function _sendAlsTracking(listingDetailDto) {
        let alsInfo = { pageToId : 2104 },
            keyMap = [
                "listingId",
                "modelYearId",
                "makeId",
                "modelId",
                "trimId",
                "stockTypeCode",
                "sellerId",
                "primaryFeedSourceId",
                "localOfferId",
                "affiliateAgentId"
            ];

        keyMap.forEach(key => alsInfo[key] = listingDetailDto[key]);
        alsService.impression(alsInfo);
    }

    function setFiveStarSalesPersonTracking() {
        const currentUpsellProductIds = pageStateService.get("page.upsell[0].productId");
        if (currentUpsellProductIds[0]) {
            currentUpsellProductIds[0] += '|empSearch';
        } else {
            currentUpsellProductIds[0] = 'empSearch';
        }
    }

    function setOnlineShopperTracking() {
        pageStateService.set('page.upsell[0].productId[0]', 'onlineShopper', false);
    }

    function setDigitalLayerPageLoadValue() {
        let affCode =  userDataService.getValue('affiliate') || 'national',
            getUserData = getLocalStoredUserData(),
            getPublicid = JSON.parse(getUserData.carsVisitor),
            deviceType = getDeviceType(),
            getPdid = getPublicid.pdid || '',
            getPcid = getPublicid.pcid,
            urlParam = $location.search();

        /* istanbul ignore if */
        if (urlParam.inventoryExtension) {
            Object.keys(urlParam).forEach(key => {
               if ( key === 'inventoryExtension' && urlParam[key] === '1') {
                   pageStateService.set('page.upsell[0].productId[0]', 'home-delivery', false);
               } else if ( key === 'inventoryExtension' && urlParam[key] === '2') {
                   pageStateService.set('page.upsell[0].productId[0]', 'shippable', false);
               } else if ( key === 'inventoryExtension' && urlParam[key] === '3') {
                   pageStateService.set('page.upsell[0].productId[0]', 'delivery-options', false);
               }
            });
        }


        let userSummary;
        try {
            userSummary = JSON.parse(localStorage.getItem('cars.UserSummary'));
            if (userSummary === null) {
                userSummary = {};
            }
        } catch (e) {
            /* istanbul ignore next */
            userSummary = {};
        }
        pageStateService.set('dataProducts.zipCode', getUserData.zip, false);
        pageStateService.set('dataProducts.affCode', affCode, false);
        pageStateService.set('dataProducts.deviceType', deviceType, false );
        pageStateService.set('dataProducts.section', (getUserData.section ? getUserData.section.replace(/\.|\//g, "_") : ''), false);
        pageStateService.set('dataProducts.lzone', (getUserData.adZoneInfo ? getUserData.adZoneInfo.split('|').slice(1)[0] : ''), false);

        pageStateService.set('user.profileInfo.loginType', userSummary.accessType, false);
        pageStateService.set('user.profileInfo.login', userSummary.email !== '', false);
        pageStateService.set('user.profileInfo.publicConsumerId', getPcid, false);
        pageStateService.set('user.profileInfo.publicDeviceId', getPdid, false);
        setSrpPositionForPageState();

        if (viewport.isMobile()) {
            latLong.getLatLong().then((coords) => {
                /* istanbul ignore next */
                pageStateService.set('user.attributes.lat', coords.latitude.toString(), false);
                /* istanbul ignore next */
                pageStateService.set('user.attributes.long', coords.longitude.toString(), false);
            }).catch((err) => {
                pageStateService.set('user.attributes.lat', '', false);
                pageStateService.set('user.attributes.long', '', false);
            }).then((data) => {
                $window.performance.mark('sendingPageImpression');
                $window.performance.measure('TimeToSendPageImpression', 'pageLoadStart', 'sendingPageImpression');
                var measures = $window.performance.getEntriesByName("TimeToSendPageImpression");
                var measure = (measures[0].duration / 1000).toFixed(1);
                pageStateService.set('page.performanceMetrics.pageImpressionSendTime', measure);
                pageStateService.push('event', {eventName: 'page-data-ready'}, true);
            });
        } else {
            pageStateService.set('user.attributes.lat', '', false);
            pageStateService.set('user.attributes.long', '', false);
            $window.performance.mark('sendingPageImpression');
            $window.performance.measure('TimeToSendPageImpression', 'pageLoadStart', 'sendingPageImpression');
            var measures = $window.performance.getEntriesByName("TimeToSendPageImpression");
            var measure = (measures[0].duration / 1000).toFixed(1);
            pageStateService.set('page.performanceMetrics.pageImpressionSendTime', measure);

            pageStateService.push('event', {eventName: 'page-data-ready'}, true);

        }
    }

    function getLocalStoredUserData() {
        const userData = localStorageService.getItem('Cars.userData');
        return (userData !== null) ? JSON.parse(userData) : {};
    }

    function getDeviceType() {
        if (viewport.isMobile()) {
            return "mobile";
        } else {
            return "desktop";
        }
    }

    function sendPageStateUpdateDTM(listing) {
        $q.all([dealerChatService.isDealerOnline(listing.customerId), sellerService.getSeller()])
            .then((data) => {
                let seller = data[1],
                    getDealerTextString = _dealerTextString(seller),
                    getDealerChatString = _dealerChatString(listing, data[0] && !data[0].error);

                pageStateService.push('page.attributes.dealerText', getDealerTextString, false);
                pageStateService.push('page.attributes.dealerChat', getDealerChatString, false);
                pageStateService.push('event', { eventName: 'post-pv-data' }, true);
            });
    }

    function _dealerTextString(seller) {
        if (viewport.isMobile()) {
            if (seller.hasVDPText) {
                return "Text: Displayed";
            } else {
                return "Text: Not-Displayed";
            }
        }
        return "";
    }

    function _dealerChatString(listing, isActuallyOnline) {
        if (!viewport.isMobile()) {
            if (listing.sellerHasDealerChatEnabled) {
                if (isActuallyOnline) {
                    return "Chat: Online";
                } else {
                    return "Chat: Offline-Displayed";
                }
            }
        }
        return "Chat: Offline-Not-Displayed";
    }

    function _updateDataVerticalPositionDTM() {
        let counter = 0;
        let elements = document.querySelectorAll('[data-vertical-position="true"]');

        for (let i = 0; i < elements.length; i++) {
            counter += 1;
            elements[i].setAttribute('data-vertical-position', counter);
        }
    }

    function setSrpPositionForPageState() {
        const srpPosition = localStorageService.getItem('srpPosition');
        if (srpPosition) {
            pageStateService.set('page.pageInfo.srpPosition', srpPosition, false);
            localStorageService.removeItem('srpPosition');
        }
    }

}

controller.$inject = ['$q', 'viewport', 'listingService', 'sellerService', 'dealerChatService', 'alsService', 'recentActivityService', 'pageStateService', 'userDataService', 'localStorageService', 'latLongService', '$window', '$location', '$document'];

export default controller;
